!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], e) : "object" == typeof exports ? exports.ReactDraggable = e(require("react"), require("react-dom")) : t.ReactDraggable = e(t.React, t.ReactDOM);
}(window, function (t, e) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 4);
  }([function (t, e, n) {
    t.exports = n(5)();
  }, function (e, n) {
    e.exports = t;
  }, function (t, n) {
    t.exports = e;
  }, function (t, e, n) {
    var r;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          var r = arguments[e];

          if (r) {
            var a = typeof r;
            if ("string" === a || "number" === a) t.push(r);else if (Array.isArray(r) && r.length) {
              var i = o.apply(null, r);
              i && t.push(i);
            } else if ("object" === a) for (var s in r) {
              n.call(r, s) && r[s] && t.push(s);
            }
          }
        }

        return t.join(" ");
      }

      t.exports ? (o.default = o, t.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(e, [])) || (t.exports = r);
    }();
  }, function (t, e, n) {
    var r = n(7),
        o = r.default,
        a = r.DraggableCore;
    t.exports = o, t.exports.default = o, t.exports.DraggableCore = a;
  }, function (t, e, n) {
    "use strict";

    var r = n(6);

    function o() {}

    function a() {}

    a.resetWarningCache = o, t.exports = function () {
      function t(t, e, n, o, a, i) {
        if (i !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
        o = n.n(r),
        a = n(0),
        i = n.n(a),
        s = n(2),
        u = n.n(s),
        c = n(3),
        l = n.n(c);

    function f(t, e) {
      for (var n = 0, r = t.length; n < r; n++) {
        if (e.apply(e, [t[n], n, t])) return t[n];
      }
    }

    function p(t) {
      return "function" == typeof t || "[object Function]" === Object.prototype.toString.call(t);
    }

    function d(t) {
      return "number" == typeof t && !isNaN(t);
    }

    function g(t) {
      return parseInt(t, 10);
    }

    function y(t, e, n) {
      if (t[e]) return new Error("Invalid prop ".concat(e, " passed to ").concat(n, " - do not set this, set it on the child."));
    }

    var h = ["Moz", "Webkit", "O", "ms"];

    function b(t, e) {
      return e ? "".concat(e).concat(function (t) {
        for (var e = "", n = !0, r = 0; r < t.length; r++) {
          n ? (e += t[r].toUpperCase(), n = !1) : "-" === t[r] ? n = !0 : e += t[r];
        }

        return e;
      }(t)) : t;
    }

    var m = function () {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "transform";
      if ("undefined" == typeof window || void 0 === window.document) return "";
      var e = window.document.documentElement.style;
      if (t in e) return "";

      for (var n = 0; n < h.length; n++) {
        if (b(t, h[n]) in e) return h[n];
      }

      return "";
    }();

    function v(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function w(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var O = "";

    function S(t, e) {
      return O || (O = f(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function (e) {
        return p(t[e]);
      })), !!p(t[O]) && t[O](e);
    }

    function D(t, e, n) {
      var r = t;

      do {
        if (S(r, e)) return !0;
        if (r === n) return !1;
        r = r.parentNode;
      } while (r);

      return !1;
    }

    function x(t, e, n) {
      t && (t.attachEvent ? t.attachEvent("on" + e, n) : t.addEventListener ? t.addEventListener(e, n, !0) : t["on" + e] = n);
    }

    function P(t, e, n) {
      t && (t.detachEvent ? t.detachEvent("on" + e, n) : t.removeEventListener ? t.removeEventListener(e, n, !0) : t["on" + e] = null);
    }

    function j(t) {
      var e = t.clientHeight,
          n = t.ownerDocument.defaultView.getComputedStyle(t);
      return e += g(n.borderTopWidth), e += g(n.borderBottomWidth);
    }

    function E(t) {
      var e = t.clientWidth,
          n = t.ownerDocument.defaultView.getComputedStyle(t);
      return e += g(n.borderLeftWidth), e += g(n.borderRightWidth);
    }

    function T(t) {
      var e = t.clientHeight,
          n = t.ownerDocument.defaultView.getComputedStyle(t);
      return e -= g(n.paddingTop), e -= g(n.paddingBottom);
    }

    function N(t) {
      var e = t.clientWidth,
          n = t.ownerDocument.defaultView.getComputedStyle(t);
      return e -= g(n.paddingLeft), e -= g(n.paddingRight);
    }

    function C(t, e, n) {
      var r = t.x,
          o = t.y,
          a = "translate(".concat(r).concat(n, ",").concat(o).concat(n, ")");

      if (e) {
        var i = "".concat("string" == typeof e.x ? e.x : e.x + n),
            s = "".concat("string" == typeof e.y ? e.y : e.y + n);
        a = "translate(".concat(i, ", ").concat(s, ")") + a;
      }

      return a;
    }

    function M(t) {
      if (t) {
        var e,
            n,
            r = t.getElementById("react-draggable-style-el");
        r || ((r = t.createElement("style")).type = "text/css", r.id = "react-draggable-style-el", r.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n", r.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n", t.getElementsByTagName("head")[0].appendChild(r)), t.body && (e = t.body, n = "react-draggable-transparent-selection", e.classList ? e.classList.add(n) : e.className.match(new RegExp("(?:^|\\s)".concat(n, "(?!\\S)"))) || (e.className += " ".concat(n)));
      }
    }

    function k(t) {
      try {
        t && t.body && (e = t.body, n = "react-draggable-transparent-selection", e.classList ? e.classList.remove(n) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(n, "(?!\\S)"), "g"), "")), t.selection ? t.selection.empty() : window.getSelection().removeAllRanges();
      } catch (t) {}

      var e, n;
    }

    function _() {
      return function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? v(n, !0).forEach(function (e) {
            w(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(n).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }

        return t;
      }({
        touchAction: "none"
      }, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
    }

    function X(t) {
      return "both" === t.props.axis || "x" === t.props.axis;
    }

    function Y(t) {
      return "both" === t.props.axis || "y" === t.props.axis;
    }

    function L(t, e, n) {
      var r = "number" == typeof e ? function (t, e) {
        return t.targetTouches && f(t.targetTouches, function (t) {
          return e === t.identifier;
        }) || t.changedTouches && f(t.changedTouches, function (t) {
          return e === t.identifier;
        });
      }(t, e) : null;
      if ("number" == typeof e && !r) return null;
      var o = I(n);
      return function (t, e) {
        var n = e === e.ownerDocument.body ? {
          left: 0,
          top: 0
        } : e.getBoundingClientRect();
        return {
          x: t.clientX + e.scrollLeft - n.left,
          y: t.clientY + e.scrollTop - n.top
        };
      }(r || t, n.props.offsetParent || o.offsetParent || o.ownerDocument.body);
    }

    function R(t, e, n) {
      var r = t.state,
          o = !d(r.lastX),
          a = I(t);
      return o ? {
        node: a,
        deltaX: 0,
        deltaY: 0,
        lastX: e,
        lastY: n,
        x: e,
        y: n
      } : {
        node: a,
        deltaX: e - r.lastX,
        deltaY: n - r.lastY,
        lastX: r.lastX,
        lastY: r.lastY,
        x: e,
        y: n
      };
    }

    function A(t, e) {
      var n = t.props.scale;
      return {
        node: e.node,
        x: t.state.x + e.deltaX / n,
        y: t.state.y + e.deltaY / n,
        deltaX: e.deltaX / n,
        deltaY: e.deltaY / n,
        lastX: t.state.x,
        lastY: t.state.y
      };
    }

    function I(t) {
      var e = u.a.findDOMNode(t);
      if (!e) throw new Error("<DraggableCore>: Unmounted during event!");
      return e;
    }

    function U(t) {
      return (U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function V(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = [],
            r = !0,
            o = !1,
            a = void 0;

        try {
          for (var i, s = t[Symbol.iterator](); !(r = (i = s.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, a = t;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (o) throw a;
          }
        }

        return n;
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function W(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function B(t) {
      return (B = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function H(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function q(t, e) {
      return (q = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function G(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var z = {
      touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
      },
      mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
      }
    },
        F = z.mouse,
        J = function (t) {
      function e() {
        var t, n, r, o;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e);

        for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++) {
          i[s] = arguments[s];
        }

        return r = this, o = (t = B(e)).call.apply(t, [this].concat(i)), n = !o || "object" !== U(o) && "function" != typeof o ? H(r) : o, G(H(n), "state", {
          dragging: !1,
          lastX: NaN,
          lastY: NaN,
          touchIdentifier: null
        }), G(H(n), "handleDragStart", function (t) {
          if (n.props.onMouseDown(t), !n.props.allowAnyClick && "number" == typeof t.button && 0 !== t.button) return !1;
          var e = u.a.findDOMNode(H(n));
          if (!e || !e.ownerDocument || !e.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
          var r = e.ownerDocument;

          if (!(n.props.disabled || !(t.target instanceof r.defaultView.Node) || n.props.handle && !D(t.target, n.props.handle, e) || n.props.cancel && D(t.target, n.props.cancel, e))) {
            var o = function (t) {
              return t.targetTouches && t.targetTouches[0] ? t.targetTouches[0].identifier : t.changedTouches && t.changedTouches[0] ? t.changedTouches[0].identifier : void 0;
            }(t);

            n.setState({
              touchIdentifier: o
            });
            var a = L(t, o, H(n));

            if (null != a) {
              var i = a.x,
                  s = a.y,
                  c = R(H(n), i, s);
              n.props.onStart, !1 !== n.props.onStart(t, c) && (n.props.enableUserSelectHack && M(r), n.setState({
                dragging: !0,
                lastX: i,
                lastY: s
              }), x(r, F.move, n.handleDrag), x(r, F.stop, n.handleDragStop));
            }
          }
        }), G(H(n), "handleDrag", function (t) {
          "touchmove" === t.type && t.preventDefault();
          var e = L(t, n.state.touchIdentifier, H(n));

          if (null != e) {
            var r,
                o,
                a,
                i = e.x,
                s = e.y;

            if (Array.isArray(n.props.grid)) {
              var u = i - n.state.lastX,
                  c = s - n.state.lastY,
                  l = V((r = n.props.grid, o = u, a = c, [Math.round(o / r[0]) * r[0], Math.round(a / r[1]) * r[1]]), 2);
              if (u = l[0], c = l[1], !u && !c) return;
              i = n.state.lastX + u, s = n.state.lastY + c;
            }

            var f = R(H(n), i, s);
            if (!1 !== n.props.onDrag(t, f)) n.setState({
              lastX: i,
              lastY: s
            });else try {
              n.handleDragStop(new MouseEvent("mouseup"));
            } catch (t) {
              var p = document.createEvent("MouseEvents");
              p.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), n.handleDragStop(p);
            }
          }
        }), G(H(n), "handleDragStop", function (t) {
          if (n.state.dragging) {
            var e = L(t, n.state.touchIdentifier, H(n));

            if (null != e) {
              var r = e.x,
                  o = e.y,
                  a = R(H(n), r, o),
                  i = u.a.findDOMNode(H(n));
              i && n.props.enableUserSelectHack && k(i.ownerDocument), n.setState({
                dragging: !1,
                lastX: NaN,
                lastY: NaN
              }), n.props.onStop(t, a), i && (P(i.ownerDocument, F.move, n.handleDrag), P(i.ownerDocument, F.stop, n.handleDragStop));
            }
          }
        }), G(H(n), "onMouseDown", function (t) {
          return F = z.mouse, n.handleDragStart(t);
        }), G(H(n), "onMouseUp", function (t) {
          return F = z.mouse, n.handleDragStop(t);
        }), G(H(n), "onTouchStart", function (t) {
          return F = z.touch, n.handleDragStart(t);
        }), G(H(n), "onTouchEnd", function (t) {
          return F = z.touch, n.handleDragStop(t);
        }), n;
      }

      var n, r, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && q(t, e);
      }(e, o.a.Component), n = e, (r = [{
        key: "componentWillUnmount",
        value: function value() {
          var t = u.a.findDOMNode(this);

          if (t) {
            var e = t.ownerDocument;
            P(e, z.mouse.move, this.handleDrag), P(e, z.touch.move, this.handleDrag), P(e, z.mouse.stop, this.handleDragStop), P(e, z.touch.stop, this.handleDragStop), this.props.enableUserSelectHack && k(e);
          }
        }
      }, {
        key: "render",
        value: function value() {
          return o.a.cloneElement(o.a.Children.only(this.props.children), {
            style: _(this.props.children.props.style),
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart,
            onMouseUp: this.onMouseUp,
            onTouchEnd: this.onTouchEnd
          });
        }
      }]) && W(n.prototype, r), a && W(n, a), e;
    }();

    function K(t) {
      return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function Q() {
      return (Q = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function Z(t, e) {
      if (null == t) return {};

      var n,
          r,
          o = function (t, e) {
        if (null == t) return {};
        var n,
            r,
            o = {},
            a = Object.keys(t);

        for (r = 0; r < a.length; r++) {
          n = a[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
        }

        return o;
      }(t, e);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);

        for (r = 0; r < a.length; r++) {
          n = a[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
        }
      }

      return o;
    }

    function $(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = [],
            r = !0,
            o = !1,
            a = void 0;

        try {
          for (var i, s = t[Symbol.iterator](); !(r = (i = s.next()).done) && (n.push(i.value), !e || n.length !== e); r = !0) {
            ;
          }
        } catch (t) {
          o = !0, a = t;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (o) throw a;
          }
        }

        return n;
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function tt(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function et(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? tt(n, !0).forEach(function (e) {
          st(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : tt(n).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }

      return t;
    }

    function nt(t) {
      return (nt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function rt(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function ot(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function at(t, e, n) {
      return e && ot(t.prototype, e), n && ot(t, n), t;
    }

    function it(t, e) {
      return (it = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function st(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    G(J, "displayName", "DraggableCore"), G(J, "propTypes", {
      allowAnyClick: i.a.bool,
      disabled: i.a.bool,
      enableUserSelectHack: i.a.bool,
      offsetParent: function offsetParent(t, e) {
        if (t[e] && 1 !== t[e].nodeType) throw new Error("Draggable's offsetParent must be a DOM Node.");
      },
      grid: i.a.arrayOf(i.a.number),
      handle: i.a.string,
      cancel: i.a.string,
      onStart: i.a.func,
      onDrag: i.a.func,
      onStop: i.a.func,
      onMouseDown: i.a.func,
      className: y,
      style: y,
      transform: y
    }), G(J, "defaultProps", {
      allowAnyClick: !1,
      cancel: null,
      disabled: !1,
      enableUserSelectHack: !0,
      offsetParent: null,
      handle: null,
      grid: null,
      transform: null,
      onStart: function onStart() {},
      onDrag: function onDrag() {},
      onStop: function onStop() {},
      onMouseDown: function onMouseDown() {}
    }), n.d(e, "default", function () {
      return ut;
    }), n.d(e, "DraggableCore", function () {
      return J;
    });

    var ut = function (t) {
      function e(t) {
        var n, r, o;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), r = this, o = nt(e).call(this, t), n = !o || "object" !== K(o) && "function" != typeof o ? rt(r) : o, st(rt(n), "onDragStart", function (t, e) {
          if (!1 === n.props.onStart(t, A(rt(n), e))) return !1;
          n.setState({
            dragging: !0,
            dragged: !0
          });
        }), st(rt(n), "onDrag", function (t, e) {
          if (!n.state.dragging) return !1;
          var r = A(rt(n), e),
              o = {
            x: r.x,
            y: r.y
          };

          if (n.props.bounds) {
            var a = o.x,
                i = o.y;
            o.x += n.state.slackX, o.y += n.state.slackY;
            var s = $(function (t, e, n) {
              if (!t.props.bounds) return [e, n];
              var r = t.props.bounds;
              r = "string" == typeof r ? r : function (t) {
                return {
                  left: t.left,
                  top: t.top,
                  right: t.right,
                  bottom: t.bottom
                };
              }(r);
              var o = I(t);

              if ("string" == typeof r) {
                var a,
                    i = o.ownerDocument,
                    s = i.defaultView;
                if (!((a = "parent" === r ? o.parentNode : i.querySelector(r)) instanceof s.HTMLElement)) throw new Error('Bounds selector "' + r + '" could not find an element.');
                var u = s.getComputedStyle(o),
                    c = s.getComputedStyle(a);
                r = {
                  left: -o.offsetLeft + g(c.paddingLeft) + g(u.marginLeft),
                  top: -o.offsetTop + g(c.paddingTop) + g(u.marginTop),
                  right: N(a) - E(o) - o.offsetLeft + g(c.paddingRight) - g(u.marginRight),
                  bottom: T(a) - j(o) - o.offsetTop + g(c.paddingBottom) - g(u.marginBottom)
                };
              }

              return d(r.right) && (e = Math.min(e, r.right)), d(r.bottom) && (n = Math.min(n, r.bottom)), d(r.left) && (e = Math.max(e, r.left)), d(r.top) && (n = Math.max(n, r.top)), [e, n];
            }(rt(n), o.x, o.y), 2),
                u = s[0],
                c = s[1];
            o.x = u, o.y = c, o.slackX = n.state.slackX + (a - o.x), o.slackY = n.state.slackY + (i - o.y), r.x = o.x, r.y = o.y, r.deltaX = o.x - n.state.x, r.deltaY = o.y - n.state.y;
          }

          if (!1 === n.props.onDrag(t, r)) return !1;
          n.setState(o);
        }), st(rt(n), "onDragStop", function (t, e) {
          if (!n.state.dragging) return !1;
          if (!1 === n.props.onStop(t, A(rt(n), e))) return !1;
          var r = {
            dragging: !1,
            slackX: 0,
            slackY: 0
          };

          if (Boolean(n.props.position)) {
            var o = n.props.position,
                a = o.x,
                i = o.y;
            r.x = a, r.y = i;
          }

          n.setState(r);
        }), n.state = {
          dragging: !1,
          dragged: !1,
          x: t.position ? t.position.x : t.defaultPosition.x,
          y: t.position ? t.position.y : t.defaultPosition.y,
          prevPropsPosition: et({}, t.position),
          slackX: 0,
          slackY: 0,
          isElementSVG: !1
        }, !t.position || t.onDrag || t.onStop || console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."), n;
      }

      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && it(t, e);
      }(e, o.a.Component), at(e, null, [{
        key: "getDerivedStateFromProps",
        value: function value(t, e) {
          var n = t.position,
              r = e.prevPropsPosition;
          return !n || r && n.x === r.x && n.y === r.y ? null : {
            x: n.x,
            y: n.y,
            prevPropsPosition: et({}, n)
          };
        }
      }]), at(e, [{
        key: "componentDidMount",
        value: function value() {
          void 0 !== window.SVGElement && u.a.findDOMNode(this) instanceof window.SVGElement && this.setState({
            isElementSVG: !0
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.setState({
            dragging: !1
          });
        }
      }, {
        key: "render",
        value: function value() {
          var t,
              e = this.props,
              n = (e.axis, e.bounds, e.children),
              r = e.defaultPosition,
              a = e.defaultClassName,
              i = e.defaultClassNameDragging,
              s = e.defaultClassNameDragged,
              u = e.position,
              c = e.positionOffset,
              f = (e.scale, Z(e, ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"])),
              p = {},
              d = null,
              g = !Boolean(u) || this.state.dragging,
              y = u || r,
              h = {
            x: X(this) && g ? this.state.x : y.x,
            y: Y(this) && g ? this.state.y : y.y
          };
          this.state.isElementSVG ? d = function (t, e) {
            return C(t, e, "");
          }(h, c) : p = function (t, e) {
            var n = C(t, e, "px");
            return w({}, b("transform", m), n);
          }(h, c);
          var v = l()(n.props.className || "", a, (st(t = {}, i, this.state.dragging), st(t, s, this.state.dragged), t));
          return o.a.createElement(J, Q({}, f, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
          }), o.a.cloneElement(o.a.Children.only(n), {
            className: v,
            style: et({}, n.props.style, {}, p),
            transform: d
          }));
        }
      }]), e;
    }();

    st(ut, "displayName", "Draggable"), st(ut, "propTypes", et({}, J.propTypes, {
      axis: i.a.oneOf(["both", "x", "y", "none"]),
      bounds: i.a.oneOfType([i.a.shape({
        left: i.a.number,
        right: i.a.number,
        top: i.a.number,
        bottom: i.a.number
      }), i.a.string, i.a.oneOf([!1])]),
      defaultClassName: i.a.string,
      defaultClassNameDragging: i.a.string,
      defaultClassNameDragged: i.a.string,
      defaultPosition: i.a.shape({
        x: i.a.number,
        y: i.a.number
      }),
      positionOffset: i.a.shape({
        x: i.a.oneOfType([i.a.number, i.a.string]),
        y: i.a.oneOfType([i.a.number, i.a.string])
      }),
      position: i.a.shape({
        x: i.a.number,
        y: i.a.number
      }),
      className: y,
      style: y,
      transform: y
    })), st(ut, "defaultProps", et({}, J.defaultProps, {
      axis: "both",
      bounds: !1,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      position: null,
      scale: 1
    }));
  }]);
});